import { motion } from 'framer-motion';
import { Box, Column, Radio, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useCheckPaymentExpiration } from '../../Inbox/Notification/Reminders/hooks/useCheckPaymentExpiration';

const buttonResetStyle = {
  all: 'unset',
  display: 'flex',
  cursor: 'pointer',
};

const opacityVariants = {
  checked: {
    opacity: 1,
  },
  unchecked: {
    opacity: 0,
  },
};

export const PaymentLine = ({
  isSelected,
  item,
  handleRadioButtonClick,
  handleMakeDefault,
  handleOnDelete,
  showActions = true,
  showExpiration = false,
}) => {
  const { checkPaymentExpiration } = useCheckPaymentExpiration();

  const { isExpired, isExpiring } = checkPaymentExpiration(item);

  const getWarningColor = () => {
    if (isExpired) {
      return colors.error[500];
    }

    if (isExpiring) {
      return colors.warning[500];
    }

    return colors.neutral[400];
  };

  return (
    <div className="global_font" data-cy="payment-line">
      <Row align="center" style={{ height: 28 }}>
        <button
          data-cy="payment-line-radio-button"
          type="button"
          style={{ ...buttonResetStyle, alignItems: 'center', width: 16 }}
          onClick={() => handleRadioButtonClick(item)}
        >
          <Radio
            value={item.id}
            checked={isSelected}
            onChange={() => handleRadioButtonClick(item)}
            size="sm"
          />
        </button>

        <Row
          justify="between"
          align="center"
          style={{ margin: '5px 20px' }}
        >
          <button
            data-cy="payment-line-info"
            type="button"
            style={{ ...buttonResetStyle, flexDirection: 'column', marginRight: 24 }}
            onClick={() => handleRadioButtonClick(item)}
          >
            <Typography size="body_large" color={colors.neutral[600]}>
              {item.brand || item.bank_name} - {item.last4}
            </Typography>
          </button>

          {item.is_selected && (
            <Box
              style={{
                height: 20,
                display: 'flex',
                alignItems: 'center',
                backgroundColor: colors.secondary[500],
                borderRadius: 4,
                marginRight: 8,
              }}
              px={2}
            >
              <Typography size="caption_sm" bold color={colors.shades[0]}>
                DEFAULT
              </Typography>
            </Box>
          )}

          {showActions && (
            <>
              {isSelected && (
                <motion.div
                  animate={isSelected ? 'checked' : 'unchecked'}
                  initial="unchecked"
                  variants={opacityVariants}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    alignSelf: 'center',
                    gap: 8,
                    marginLeft: !item.is_selected && item.isExpired ? -8 : 0,
                  }}
                >
                  {!item.is_selected && !item.isExpired && (
                    <button
                      data-cy="btn-payment-line-make-default"
                      type="button"
                      style={{
                        ...buttonResetStyle,
                        fontWeight: 700,
                        color: colors.secondary[500],
                      }}
                      onClick={() => handleMakeDefault(item.id)}
                    >
                      <Typography size="body_large" bold color={colors.secondary[500]}>
                        Make Default
                      </Typography>
                    </button>
                  )}
                  <Typography size="body_large" color={colors.neutral[600]}>
                    |
                  </Typography>
                  <button
                    data-cy="btn-payment-line-delete"
                    type="button"
                    style={{ ...buttonResetStyle }}
                    onClick={() => handleOnDelete(item)}
                  >
                    <Typography size="body_large" bold color={colors.secondary[500]}>
                      Delete
                    </Typography>
                  </button>
                </motion.div>
              )}
            </>
          )}
        </Row>
      </Row>

      {showExpiration && (
        // marginTop: -4 pulls the expiration line up under the payment row
        <Column style={{ marginLeft: 36, marginTop: -4 }}>
          <Typography size="body_small" color={getWarningColor()}>
            Expires: {item.expirationDate.format('MM/YY')}
          </Typography>
        </Column>
      )}
    </div>
  );
};
